import type { LucideIcon } from "lucide-react";

import { ANALYTICS_CHART_TOOLBAR_BUTTON_CLASS } from "./constants";

import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface AnalyticsChartToolbarButtonProps {
  ariaLabel: string;
  disabled?: boolean;
  icon: LucideIcon;
  onClick: () => void;
  tooltip: string;
}

const AnalyticsChartToolbarButton = ({
  ariaLabel,
  disabled = false,
  icon: Icon,
  onClick,
  tooltip,
}: AnalyticsChartToolbarButtonProps) => (
  <BasicTooltip content={tooltip}>
    <Button
      type="button"
      variant="ghost"
      size="icon"
      disabled={disabled}
      onClick={onClick}
      className={ANALYTICS_CHART_TOOLBAR_BUTTON_CLASS}
      aria-label={ariaLabel}
    >
      <Icon className="h-4 w-4" />
    </Button>
  </BasicTooltip>
);

export default AnalyticsChartToolbarButton;
